import DocIcon from 'Assets/images/commons/iconDoc.svg';
import XslIcon from 'Assets/images/commons/iconXsl.svg';
import FileIcon from 'Assets/images/commons/otherFileIcon.svg';
import PdfIcon from 'Assets/images/commons/pdfFileIcon.svg';
import { fileTypeByMime } from 'Constants/commons';
import PrivateImage from 'Modules/PrivateImage/PrivateImage';
import PropTypes from 'prop-types';

const FileIconView = ({ file }) => {
  const { mime, thumbPath } = file;
  const fileType = fileTypeByMime(mime);
  switch (fileType) {
    case 'image':
      return <PrivateImage style={{ maxWidth: '100%' }} src={thumbPath} alt="" />;
    case 'doc':
      return <img src={DocIcon} alt="doc" />;
    case 'pdf':
      return <img src={PdfIcon} alt="pdf" />;
    case 'xsl':
      return <img src={XslIcon} alt="xls" />;
    default:
      return <img src={FileIcon} alt="file" />;
  }
};

FileIconView.propTypes = {
  file: PropTypes.shape({
    mime: PropTypes.string.isRequired,
    thumbPath: PropTypes.string.isRequired,
  }).isRequired,
};

export default FileIconView;
